import { render, staticRenderFns } from "./CollarStyle.vue?vue&type=template&id=7b0ab135&scoped=true&"
import script from "./CollarStyle.vue?vue&type=script&lang=js&"
export * from "./CollarStyle.vue?vue&type=script&lang=js&"
import style0 from "./CollarStyle.vue?vue&type=style&index=0&id=7b0ab135&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0ab135",
  null
  
)

export default component.exports